import { HeadingType } from '@rappider/rappider-components/utils';

export const defaultToolbarTitleHeadingSize = HeadingType.H5;
